<template>
  <div class="nav">
    <div class="top">
      <img src="../../assets/about/beijing.png" width="100%" height="130px"
           style="margin-top: 18%;">
      <p class="mtcal">关于我们</p>
      <div class="btnBox">
<!--        <el-button class="btn">联系我们</el-button>-->
        <span class="fontSize">&emsp;国产自主可控区块链技术领军者</span>
      </div>
    </div>
    <div class="center">
      <el-row>
        <el-col :span="19">
          <div class="top-title" style="justify-content: space-between;">
            <p class="title">公司简介</p>
            <!-- <img src="../../assets/about/left.png" style="width: 100px;height: 282px"> -->
            <div class="border"></div>
          </div>
          <div class="text" style="width: 100%;">
            <p>
              湖南宸瀚科技有限公司成立于2015年，是国产自主可控区块链技术领军者、中国区块链服务先行者、区块链全生态解决方案提供商、无人集群分布式群体智能协同服务商。提供群体智能协同、数据可信空间技术、解决方案、产品。
            </p>
            <p>
              公司以区块链隐私计算群体智能技术为核心构建的去中心化大规模新型网络架构组网、数据分布式智能协同组织管理应用、无人集群高鲁棒抗干扰智能协同技术，建设未来数字世界生态，聚焦三大业务板块：数据安全业务、无人集群业务、运维保障业务。拥有多项先进成果，通过国家网信办境内区块链信息服务备案9项，取得知识产权50余项，出版专著《DAG区块链技术：原理与实践》。 公司自主研发的智信链（MT）国产高性能区块链基础平台，是国内纯国产化的区块链基础平台，入选了“湖南省大数据和区块链产业发展重点项目”、“工信部信息技术应用创新解决方案”、“网信自主创新优秀解决方案”等；研发的智信云区块链BaaS平台，入选了“湖南省‘数字新基建’100个标志性项目”；研发的MP区块链隐私计算安全服务平台，入选了“工信部网络安全应用示范试点项目”。公司推出了50多个区块链行业解决方案和应用平台，可为政府、企业各行业各场景区块链应用提供坚实技术支撑。
            </p>
            <p>公司具有国家高新技术企业、中国区块链百强企业、区块链规划论证单位、科技型中小企业、湖南省技术先进型服务企业、湖南省专精特新企业等多种资质。</p>
            <p>公司秉承“胸怀祖国、团结协作、志在高峰、奋勇拼搏”的理念，始终坚持以国产自主可控区块链核心技术自主创新为根本，矢志为推动中国区块链技术和产业创新发展贡献力量！
            </p>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="block">
      <div class="top-title">
        <p class="title">联系我们</p>
        <div class="border"></div>
      </div>
      <div style="padding:0 10px">
        <div class="box-big" style="line-height: 50px">
        <img src="../../assets/about/Bitmap.png" style="position: absolute;margin-top: 180px">
        <div class="tab-box">
          <el-tabs :tab-position="tabPosition">
            <el-tab-pane label="公司总部" class="big-div">
                <div class="mapBox">
                  <baidu-map class="map" :center="{lng: 112.889768, lat: 28.237858}" :zoom="zoom">
                    <bm-marker :position="{lng: 112.889768, lat: 28.237858}" @click="lookDetail()">
                      <bm-label
                          content="<div>
                    <p>地址：湖南省长沙市岳麓区国家网络安全产业园区8B栋11楼</p>
                    <p>电话：0731-85584896</p>
                    <p>官网：www.trilliontrust.com</p>
                    <p>邮箱：services@trilliontrust.com</p>
              </div>"
                          :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"
                          :offset="{width: 4,height:2}"
                      ></bm-label>
                    </bm-marker>
                  </baidu-map>
              </div>

            </el-tab-pane>
            <el-tab-pane label="湖南宸瀚"  class="big-div">
              <div class="mapBox">
                <baidu-map class="map" :center="{lng: 112.88945, lat: 28.238566}" :zoom="zoom">
                  <bm-marker :position="{lng: 112.889768, lat: 28.237858}">
                    <bm-label
                      content="<div>
                    <p>地址：湖南省长沙市岳麓区国家网络安全产业园区8B栋11楼</p>
                    <p>电话：0731-85584896</p>
                    <p>官网：www.chenhaninfo.com</p>
                    <p>邮箱：services@chenhaninfo.com</p>
              </div>"
                          :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"
                          :offset="{width: 4,height:2}"
                    ></bm-label>
                  </bm-marker>
                </baidu-map>
              </div>
            </el-tab-pane>
<!--            <el-tab-pane label="四川宸瀚"  class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng: 104.058585, lat: 30.641999}" :zoom="zoom">-->
<!--                  <bm-marker :position="{lng: 104.058585, lat: 30.640807}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：成都市武侯区一环路西一段130号1栋24层2413号</p>-->
<!--                    <p>联系人：曹先生 15856662266</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="北京宸瀚元宇"  class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng: 116.233768, lat: 40.085018}" :zoom="zoom">-->
<!--                  <bm-marker :position="{lng: 116.234139, lat: 40.084734}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：北京市海淀区永澄北路2号院1号楼A座三层305-09号</p>-->
<!--                    <p>联系人：张先生 19930699991</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="江苏瀚宸" class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng: 118.825879, lat:32.033932}" :zoom="18">-->
<!--                  <bm-marker :position="{lng: 118.826319, lat: 32.03361}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：南京市秦淮区标营4号秦淮硅巷国际创新广场2号楼202室</p>-->
<!--                    <p>联系人：曹先生 15856662266</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="浙江智数" class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng: 120.065714, lat:30.546872}" :zoom="18">-->
<!--                  <bm-marker :position="{lng: 120.06642, lat:30.546098}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：浙江省湖州市德清县康乾街道图灵路1号智能生态城5幢1楼101-7</p>-->
<!--                    <p>联系人：曹先生 15856662266</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="西安宸瀚" class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng: 108.879931, lat:34.199669}" :zoom="18">-->
<!--                  <bm-marker :position="{lng: 108.880296, lat:34.199276}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：陕西省西安市高新区锦业路38号粤汉国际D座1711号</p>-->
<!--                    <p>联系人：来先生 18973173812</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="江西宸瀚信链" class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng:115.805974, lat:28.614554}" :zoom="18">-->
<!--                  <bm-marker :position="{lng:115.806298, lat:28.614057}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：江西省南昌市红谷滩区九龙大道和风顺东街交叉口中国南昌虚拟现实VR产业基地2号楼8楼</p>-->
<!--                    <p>联系人：邓先生 18878850068</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="云南宸瀚" class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng:102.667869, lat:25.092811}" :zoom="18">-->
<!--                  <bm-marker :position="{lng:102.668388, lat:25.092483}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：云南省昆明市五华区科普路505号五华科创大厦23楼26号房</p>-->
<!--                    <p>联系人：邓先生 15856662266</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="广西宸瀚" class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng:108.40965, lat:22.81374}" :zoom="18">-->
<!--                  <bm-marker :position="{lng:108.410205, lat:22.813216}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：南宁市青秀区朱槿路16号菲律宾园·金菲豪园5号楼2单元401号</p>-->
<!--                    <p>联系人：邓先生 18878850068</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
<!--            <el-tab-pane label="广东链融" class="big-div">-->
<!--              <div class="mapBox">-->
<!--                <baidu-map class="map" :center="{lng:113.509924, lat:23.159667}" :zoom="18">-->
<!--                  <bm-marker :position="{lng:113.51199, lat:23.159036}">-->
<!--                    <bm-label content="<div>-->
<!--                    <p>地址：广州市黄埔区瑞和路39号D座5楼526房纳金·We创众创空间</p>-->
<!--                    <p>联系人：邵先生 13486952052</p>-->
<!--              </div>"-->
<!--                              :labelStyle="{color: '#fff',fontSize : '12px',padding:'10px',borderRadius:'5px',marginLeft:'18px', marginTop:'-30px', background:'rgba(5, 97, 255, 0.9)',borderColor:'rgba(5, 97, 255, 0.9)'}"-->
<!--                              :offset="{width: 4,height:2}"-->
<!--                    ></bm-label>-->
<!--                  </bm-marker>-->
<!--                </baidu-map>-->
<!--              </div>-->
<!--            </el-tab-pane>-->
          </el-tabs>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about-app.vue",
  data() {
    return {
      isShow: false,
      tabPosition: 'top',
      center: '',
      zoom: 18,　 //地图展示级别
      addressList: [
        {
          name: "公司总部",
          addressData: {
            address: "湖南省长沙市岳麓区国家网络安全产业园区8B栋11楼",
            phone: "0731-85584896",
            http: "www.trilliontrust.com",
            email: "services@trilliontrust.com"
          }
        },
        {
          name: "湖南宸瀚",
          addressData: {
            address: "湖南省长沙市岳麓区国家网络安全产业园区8B栋11楼",
            phone: "0731-85584896",
            http: "www.chenhaninfo.com",
            email: "services@chenhaninfo.com"
          }
        },
        {
          name: "四川宸瀚",
          addressData: {
            address: "成都市武侯区一环路西一段130号1栋24层2413号",
            phone: "0731-85404820"
          }
        },
        {
          name: "深圳宸瀚",
          addressData: {
            address: "深圳市南山区南头街道莲城社区深南大道10128号南山软件园A2402",
            phone: "0731-85404820"
          }
        },
        {
          name: "哈希奈特北京",
          addressData: {
            address: "北京市海淀区北三环西路32号6层602室",
            phone: "010-67191919",
          }
        },
        {
          name: "浙江物信",
          addressData: {
            address: "浙江省金华市金磐开发区尖山路277号都市郦景园D幢104室",
          }
        },
      ],
      addressIndex: 0

    }

  },
  methods: {
    // 点击点坐标赋值
    lookDetail() {

      console.log(123)
    },
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-tabs__nav .el-tabs__item {
  font-size: 12px;
  //border-right: 2px solid #055EFF;
  color: #A6C6FF;
  padding: 0 10px;
}

/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left::after, .el-tabs--left .el-tabs__nav-wrap.is-right::after, .el-tabs--right .el-tabs__nav-wrap.is-left::after, .el-tabs--right .el-tabs__nav-wrap.is-right::after {
  height: 0%;
  width: 0px;
  bottom: 0;
  top: 0;
}

/deep/ .el-tabs__nav-next{
  color: #fff;

}

/deep/ .el-tabs__nav-prev{
  color: #fff;
}

/deep/ .el-tabs__nav .el-tabs__item:hover {
  color: #FFFFFF;
}

/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev, .el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev, .el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev, .el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev {
  color: #FFFFFF;
  font-weight: bold;
}

/deep/ .el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-next i, .el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev i, .el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-next i, .el-tabs--left .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev i, .el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-next i, .el-tabs--right .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev i, .el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-next i, .el-tabs--right .el-tabs__nav-wrap.is-right > .el-tabs__nav-prev i {
  color: #FFFFFF;
  font-weight: bold;
}

.nav {
  background-color: #fff;
  width: 100%;

  .top {
    // margin-top: 78px;
    height: 280px;
    width: 100%;
    background-color: #F5F9FC;
  }

  .box-big {
    margin-top: 61px;
    width: 100%;
    height: 376px;

    background: #055EFF;
    border-radius: 10px;
    margin-left: 0%;

    .tab-box {
      font-size: 18px;

    }

  }

  .fontSize {
    // width: 100px;
    height: 28px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    // font-weight: 500;
    color: #2D3036;
    line-height: 28px;
    position: relative;
    top: -2px;
    margin-left: 15.5%;
  }

  .mtcal {
    // width: 100%;
    height: 63px;
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #282B31;
    line-height: 30px;
    margin-left: 15.5%;
    // padding-top: 20px;
  }

  .btnBox {
    margin-top: -5%;
    margin-left: 8.5%;
  }

  .btn {
    width: 139px;
    height: 39px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 16px;
    background: #0069FD;
    border-radius: 20px;
  }

  .top-title {
    padding: 50px 0 35px;
    margin-left: 15px;

    .title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #282F3C;
      margin-left: 4px;
    }

    .border {
      width: 80px;
      height: 3px;
      margin-top: 3px;
      background-color: #056DFF;
    }
  }

  .text {
    /*margin-right: 125px;*/
    padding: 0px 25px 0px 35px;

    p {

      line-height: 38px;
      margin: 15px 0;
      color: #5a5a5a;
    }
  }

  .block {
    width: 100%;
    // margin-left: 2.5%;
    padding-bottom: 64px;

    .top-title {
      padding: 50px 0 35px;
      margin-left: 15px;

      .title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #282F3C;
        margin-left: 4px;
      }

      .border {
        width: 80px;
        height: 3px;
        margin-top: 3px;
        background-color: #056DFF;
      }
    }

    .title {

      &:after {
        content: '';
        display: inline-block;
        position: absolute;
        bottom: -5px;
        opacity: 1;
        left: 50%;
        height: 6px;
        width: 6%;
        /*background: linear-gradient(50deg, rgba(0, 180, 255, 1), rgba(3, 201, 237, 1));*/
        background-color: #ccffff;
        box-shadow: 0px 3px 6px 0px rgba(52, 126, 255, 0.25);
        z-index: -1;
      }
    }

    .text {
      p {
        line-height: 38px;
        margin: 30px 0;
        color: #5a5a5a;
      }
    }
    .big-div{
      border-radius: 20px;
      width:98%;
      height: 260px;
      border: 1px solid #fff;
      margin-top: 14px;
      margin-left:2px;
      padding: 0;
      background-color: #fff

    }
    .mapBox {
      padding: 5px;
      .map {
        width: 100%;
        height: 251px;
        position: relative;
      }

    }

    .address {
      margin-left: 160px;
      margin-top: 30px;
      padding-bottom: 20px;

      .addressList {
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        .addressItem {
          min-height: 60px;
          line-height: 60px;
          font-size: 18px;
          margin: 0 40px;
          transition: all 0.5s;
          cursor: pointer;
        }

        .active {
          font-size: 28px;
          font-weight: 600;
        }
      }

      .addressBox {
        p {
          margin: 20px 0px;

          span {
            padding-left: 40px;
            font-size: 18px;
          }

          b {
            font-size: 18px;
          }
        }
      }
    }
  }
}

</style>
